
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import Editor from '@tinymce/tinymce-vue';
import Store from '@/store/index';
import AppConst from '@/lib/appConst';
import common from '@/lib/common';
import UserProfile from '@/store/entities/auth/UserProfile';
import GenderRadios from '@/components/gender-radios.vue';

@Component({
    components: {
        Editor,
        GenderRadios
    }
})
export default class EditUserProfile extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    editMode: string;
    currentTab: string = "detail";
    title: string = this.L('UserProfile');
    userProfile: UserProfile = new UserProfile();
    editorOptions: any = {
        plugins: 'image',
        image_uploadtab: true,
        height: 400,
        images_upload_handler: function (blobInfo, success, failure) {
            var formData = new FormData();
            formData.append('file', blobInfo.blob(), blobInfo.filename());
            formData.append('usage', 'AuthUserProfileEditors');
            var location = Store.dispatch({
                type: 'imageManager/uploadImage',
                data: formData
            });
            success(location);
        }
    };
    uploadHeaders: any = {
        Authorization: "Bearer " + Util.abp.auth.getToken(),
        TenantId: Util.abp.multiTenancy.getTenantIdCookie()
    };
    uploadUrl: string = '';
    saveLoading: boolean = false;
    phoneNumber: string = Util.abp.session.getPhoneNumberCookie();
    userProfileRules = {
        fullName: [{ required: true, message: this.L('ThisFieldIsRequired', undefined, this.L('FullName')) }],
        identificationCardNo: [{ required: true, message: this.L('ThisFieldIsRequired', undefined, this.L('IdentificationCardNo')) }]
    };

    save() {
        (this.$refs.userProfileForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.saveLoading = true;
                await this.$store.dispatch({
                    type: 'userProfile/' + this.editMode.toLowerCase(),
                    data: this.userProfile
                }).then(() => {
                    this.$emit('save-success');
                    this.$emit('input', false);
                    this.saveLoading = false;
                    this.$Message.success(this.L('SavedSuccessfully'));
                });
            }
        })
    }
    created() {
        this.uploadUrl = common.getUploadUrl('AuthUserProfile');
        this.$store.dispatch({
            type: 'userProfile/getByUserNo',
            data: Util.abp.session.getUserNoCookie()
        }).then((data) => {
            this.userProfile = Util.extend(true, {}, data);
            this.editMode = !this.userProfile.id ? 'create' : 'update';
            if (this.editMode === 'create') {
                var model = new UserProfile();
                this.userProfile = Util.extend(true, {}, model);
            }
        }).catch(err => {
            this.$Modal.error({ title: this.L('Tips'), content: err });
        });
    }
    handleTabChanged(e) {
        this.currentTab = e;
    }
    handleBeforeUpload(file) {
        var validationResult = Util.validateImageFile(file);
        if (!validationResult.result) {
            this.$Notice.warning({
                title: this.L('Tips'),
                desc: validationResult.msg
            });
            return false;
        }
        return true;
    }
    handleUploadSuccess4AvatarImageUrl(res, file) {
        this.userProfile.avatarImageUrl = res.result.location;
    }
    handleRemoveImage(fileName: string, onRemoved) {
        this.$Modal.confirm({
            title: this.L('Tips'),
            content: '<div style="word-wrap:break-word">' + this.L("DeleteConfirm") + '</div>',
            onOk: () => {
                this.$store.dispatch({
                    type: 'imageManager/deleteImage',
                    data: {
                        imageUrl: fileName
                    }
                }).then(() => {
                    if (onRemoved) {
                        onRemoved();
                    }
                    this.$Notice.success({
                        title: this.L('Tips'),
                        desc: fileName + this.L('Delete') + this.L('Success')
                    });
                });
            }
        });
    }

    handleBeganWorkDayChange(value: any) {
        this.userProfile.beganWorkDay = value;
    }
    handleBirthdayChange(value: any) {
        this.userProfile.birthday = value;
    }


}
